import React, { Component } from "react"
import { isMobile } from "react-device-detect"

export default class LinkListAccordion extends Component {
  showHideContent(event, classname) {
    const sel = getSelection().toString()
    if (!sel) {
      let elem = event.currentTarget.parentElement
      elem.__toggle = !elem.__toggle
      let target = elem.querySelector(classname)
      let parentAccordion = elem.closest(classname)
      if (elem.__toggle) {
        target.style.height = target.scrollHeight + "px"
        elem.classList.add("open")
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const combinedHeight = parentHeight + target.scrollHeight
          parentAccordion.style.height = combinedHeight + "px"
        }
      } else {
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const reducedHeight = parentHeight - target.scrollHeight
          parentAccordion.style.height = reducedHeight + "px"
        }
        target.style.height = 0 + "px"
        elem.classList.remove("open")
      }
    }
  }

  render() {
    return (
      <div className="article-overview-block-covid">
        <div className="w--wider">
          <div className="grid">
            {this.props.blocks && this.props.blocks.length > 0
              ? this.props.blocks.map((block, index) => {
                  return (
                    <div key={index} className="grid-item col--12 col-sm--4">
                      <div className="article-overview-block-covid__item foldable">
                        <div
                          className="article-overview-block-covid__header"
                          onClick={isMobile ? (e) => this.showHideContent(e, ".contentWrapper") : undefined}
                        >
                          <a href={block.headlineLink ? block.headlineLink : undefined}>{block.headline}</a>
                        </div>
                        <div className="contentWrapper show-hide">
                          <div className="article-overview-block-covid__list">
                            {block.linkBlocks && block.linkBlocks.length > 0 ? (
                              <ul>
                                {block.linkBlocks.map((linkBlock, linkIndex) => {
                                  return (
                                    <li key={linkIndex}>
                                      <a href={linkBlock.linkUrl ? linkBlock.linkUrl : undefined}>{linkBlock.linkText}</a>
                                    </li>
                                  )
                                })}
                              </ul>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              : ""}
          </div>
        </div>
      </div>
    )
  }
}
